import { useTranslation } from 'react-i18next';
import ProfileIcon from '../../../assets/icons/profile.svg?react';
import { evaluateKpiSeverity } from './kpiSeverity';
import type { BedResource } from './types';
import styles from './OverbookingPopover.module.css';

interface OverbookingPopoverProps {
  bedResources: readonly BedResource[];
}

export const OverbookingPopover = ({ bedResources }: OverbookingPopoverProps) => {
  const { t } = useTranslation();
  const overbooked = bedResources.filter(
    (resource) => evaluateKpiSeverity(resource.used, resource.threshold) === 'EXCEEDED',
  );

  return (
    <div className={styles.popover}>
      {overbooked.map((resource) => (
        // TODO: BE will return localized title; for now the mock supplies Danish copy.
        <section key={resource.title} className={styles.section}>
          <div className={styles.title}>{resource.title}</div>
          <div className={styles.affectedHeader}>{t('gantt-overbooking-affected')}</div>
          <ul className={styles.patientList}>
            {resource.affectedPatients.map((name) => (
              <li key={name} className={styles.patientRow}>
                <ProfileIcon className={styles.patientIcon} aria-hidden="true" />
                {name}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};
